import React from "react"

const Name = ({ param, parent }) => (
  <label>
    <a href={`#${encodeURI(param.anchor)}`} data-display-anchor>
      {parent?.type === "array" && "["}
      {parent?.key && <span>{parent?.key}</span>}
      {parent?.type === "array" && "]."}
      {parent?.type === "object" && "."}
      {param.key}
    </a>
  </label>
)

export default Name
